import { getAuthToken } from '../hooks'

function getBrandingHeaders() {
  const brandingId = sessionStorage.getItem('session_branding_id')
  return brandingId ? { 'x-branding-id': brandingId } : {}
}

// Stream file from the api, with bearer token auth
export const openApiFile = async (path) => {
  const response = await fetch(`${process.env.REACT_APP_API_HOST}${path}`, {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
      ...getBrandingHeaders(),
    },
  })

  if (!response.ok) {
    let errorMessage = `Failed to download file: ${response.status} ${response.statusText}`
    try {
      const errorBody = await response.json()
      errorMessage = errorBody.message || errorMessage
    } catch {
      // Response wasn't JSON, use default message
    }
    throw new Error(errorMessage)
  }

  const file = window.URL.createObjectURL(await response.blob())
  const filename =
    response.headers.get('Content-Disposition')?.replace(/.*filename="([^"]+)"/, '$1') ?? 'givewise-pdf.pdf'

  // Trigger download
  const anchor = document.createElement('a')
  document.body.appendChild(anchor)
  anchor.href = file
  anchor.download = filename
  anchor.click()
  anchor.remove()
  window.URL.revokeObjectURL(file)
}

export const openApiFileWithData = async (path, data) => {
  const response = await fetch(`${process.env.REACT_APP_API_HOST}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
      'Content-Type': 'application/json',
      ...getBrandingHeaders(),
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`)
  }

  const blob = await response.blob()
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      const base64data = reader.result.split(',')[1] // Get base64 string
      resolve(base64data)
    }
    reader.onerror = () => reject(new Error('Error reading blob as base64'))
    reader.readAsDataURL(blob) // Convert blob to base64
  })
}
